import {  useState, useEffect, useRef } from "react";
import { Form } from 'reactstrap';
import { APILA } from "../../../../../../config/apila";
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faFloppyDisk } from '@fortawesome/free-solid-svg-icons';

export default function ModalRoleAdd(props) {
  const token = localStorage.getItem("token");

  const [isSubmitting, setIsSubmitting] = useState(false);

  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const safeValue = (value) => value ?? "";

  const [form, setForm] = useState({
    id_element: "",
    description: "",
    user_id:"",
  });

  // =========================================
  // MENGISI DATA UPDATE
  // =========================================
  useEffect(() => {
    if (!props?.show) {
      return;
    }

    setForm({
      id_element: safeValue(
        props?.dataUpdate?.id_element
      ),

      description: safeValue(
        props?.dataUpdate
          ?.description
      ),

      user_id: safeValue(
        props?.dataUpdate
          ?.idUser
      ),
    });
  }, [props?.show, props?.dataUpdate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,
    }));
  };

  // const handleSubmit = useMutation(async (e) => {
  const handleSubmit = useMutation(async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await APILA.put(`/api/sub-elements/${props.id}`, {
        id_element: form?.id_element,
        description: form?.description,
        user_id: idUser,
      }, fetchParams);
  
      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: 'success',
          title: response.data.message,
        })
        props.GetResponseData();
        props.onHide();
      }

    } catch (error) {
      ToastError.fire({
        icon: 'error',
        title: `${error.response.data.message}`,
      })
      setIsSubmitting(false);
    }
  });

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-update-kkca"
    >
      <div className="sims-modal-header">
        <div>
          <h5 id="modal-update-kkca" className="sims-modal-title">
            Update Element {props.namaElement}
          </h5>
        </div>

        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          aria-label="Tutup modal"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <Form onSubmit={(event) => handleSubmit.mutate(event)}>
        <div className="sims-modal-body">

          <div className="mt-4 label-group-form" hidden >
            <label className="label-name-form">
              ID Element
            </label>
            <input className="label-input-form"  autoFocus type='text' name="id_element" onChange={handleChange} value={form?.id_element}   
              placeholder='Masukan Label Jenjang'/>
            <style>{`input::placeholder { color: #B9B9B9;}`}
             </style>
          </div>


          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="indikator_update">
              Indikator <span>*</span>
            </label>
            
            <textarea
              id="indikator_update"
              className="sims-form-input pt-2"
              rows={6}
              style={{ minHeight: 140, resize: "vertical" }}
              name="description"
              value={form.description}
              onChange={handleChange}
              required
            />
          </div>

          
        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                Memperbarui...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFloppyDisk} />
                Perbarui
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
    
  );
}
  